// extracted by mini-css-extract-plugin
export default {"StyleButton":"Button_StyleButton__1F75e"};